import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { TranslationContext } from '../../../contexts/TranslationContext';

export default function RedirectNotFound() {
  const { setCurrentLanguage } = useContext(TranslationContext);
  setCurrentLanguage('ka');
  return <Navigate to="/ka" replace />;
}
